import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  company_name: string;
  country: number;
  entity_type: number;
  registration_number: string;
  date_of_incorporation: string | null;
  external_reference?: string | null;
  individual_reference?: string | null;
  pep_and_sanction_required: boolean;
  adverse_media_required: boolean;
  primary_division?: number;
  primary_team?: number;
  /** Ids of Divisions/Teams the record is also shared into. */
  additional_divisions?: number[];
  additional_teams?: number[];
}

export const useCreateEntityMonitoring = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/entity_monitoring/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
